import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-button',
  templateUrl: './page-button.component.html',
  styleUrls: ['./page-button.component.scss']
})
export class PageButtonComponent {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";


  constructor() { }

}
